import { render, staticRenderFns } from "./OrganisationDomainCustom.vue?vue&type=template&id=c0bc76fc&"
import script from "./OrganisationDomainCustom.vue?vue&type=script&lang=ts&"
export * from "./OrganisationDomainCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports